export const ProfileActions = {
  UpdateRecentAccessEntries: 'updateRecentAccess',
  UpdateRecentActionsEntries: 'updateRecentActions',
  UpdateRecentViewEntries: 'udpateRecentViewEntries',
  UpdateUserData: 'updateUserDetails',
  SaveUserDetails: 'saveUserDetails',
  CheckIfUsernameIsTaken: 'checkIfUsernameIsTaken',
  FetchUserAllowedRoles: 'ProfileActions.FetchUserAllowedRoles',
  ImpersonateUser: 'ProfileActions.ImpersonateUser',
  ToggleUserActive: 'ProfileActions.ToggleUserActive',
  SendChangeInstructions: 'ProfileActions.SendChangeInstructions'
};

export const ProfileMutations = {
  SetRecentAccessEntries: 'setUpdateRecentAccess',
  SetRecentActionsEntries: 'setUpdateRecentActions',
  SetRecentViewEntries: 'setRecentViewEntries',
  SetCurrentData: 'setCurrentData',
  UpdateRole: 'updateUserRoles',
  SetUserAllowedRoles: 'ProfileMutations.SetUserAllowedRoles',
  SetUserActiveInactive: 'ProfileMutations.SetUserActiveInactive',
  IsPasswordReset: 'ProfileMutations.IsPasswordReset'
};

export const ProfileGetters = {
  GetRecentAccessEntries: 'getUpdateRecentAccess',
  GetRecentActionsEntries: 'getUpdateRecentActions',
  GetRecentViewEntries: 'getUpdateRecentViewEntries',
  GetUserDetails: 'getUserDetails'
};
